import type { TextValue } from '../../../types/form/form-fields/field-values';
import type { ConstraintFunction } from '../../../types/form/form-section/config';

export const textValueContainsCheck: ConstraintFunction<TextValue> = (
	value: TextValue | undefined,
	constraint: string[],
) => value !== undefined && value.text.toLowerCase().includes(constraint[0]?.toLowerCase());

export const textValueDoesNotContainCheck: ConstraintFunction<TextValue> = (
	value: TextValue | undefined,
	constraint: string[],
) => value === undefined || !value.text.toLowerCase().includes(constraint[0]?.toLowerCase());

export const textValueEqualToCheck: ConstraintFunction<TextValue> = (
	value: TextValue | undefined,
	constraint: string[],
) => value !== undefined && value.text === constraint[0];

export const textValueDoesNotEqualCheck: ConstraintFunction<TextValue> = (
	value: TextValue | undefined,
	constraint: string[],
) => value === undefined || value.text !== constraint[0];

export const textValueEmptyCheck: ConstraintFunction<TextValue> = (value: TextValue | undefined) =>
	value === undefined || value.text.trim().length === 0;

export const textValueNotEmptyCheck: ConstraintFunction<TextValue> = (
	value: TextValue | undefined,
) => value !== undefined && value.text.trim().length > 0;
